<template>
  <div class="recruiter ico-browser font_Montserrat v3_color_black_knight px-3">
    <div class="text-center mb-20">
      <b class="v3_color_teal"> Describe your job and immediately see how many candidates are interested in the opportunity.  
      </b>
    </div>
    <div>
      <b-card class="mt-2 v3_box_teal" no-body>
        <b-card-body class="v3_box_teal_body">
          <div class="box-body-wrapper flex-column p-4">
            <b class="v3_color_teal"> Find Your Perfect Candidates</b>
            <p />
            <b-row class="w-100 mt-3">
              <b-col class="" lg="3" md="4" sm="12">
                <recruiter-ico-criteria
                  :criteria-items="criteriaItems"
                  :loading="!criteriaItems.length"
                >
                  <template slot-scope="{ items, getLabel }">
                    <div
                      class="d-flex flex-column justify-content-stretch mt-3"
                    >
                      <template v-for="item in items">
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          :set="(disabled = !isSpecialtySubspecialtySpecified 
                            && item.type !== JOB_QUESTION_TYPES.SPECIALTY
                          )"
                          class="d-flex flex-column justify-content-stretch"
                          tabindex="0"
                        >
                          <b-button
                            :class="[
                              'mb-2 text-break',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled="disabled"
                            @click="onChangeCriteria(item)"
                            variant="v3_teal_outline"
                          >
                            {{ getLabel(item) }}
                          </b-button>
                        </div>
                        <b-tooltip
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                          v-if="disabled"
                        >
                          This criteria is not active until a specialty /
                          sub-specialty is chosen.
                        </b-tooltip>
                      </template>
                    </div>
                  </template>
                </recruiter-ico-criteria>
              </b-col>
              <b-col class="" lg="6" md="8" sm="12">
                <div class="border_1 border_light_teal h-100 w-100 p-3">
                  <template v-if="selectedJobQuestion">
                    <recruiter-ico-criteria-detail
                      :job-question="selectedJobQuestion"
                      :loading-detail="loadingDetail"
                      @set-criteria-value="onSetCriteriaValue"
                      :filter-user-count="true"
                    />
                  </template>
                  <template v-else>
                    <div class="d-flex align-items-center mt-5 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <span>
                          1. Select and define required Job Criteria to build your job.
                        </span><p />
                        <span>
                          2. Assess “Number of Matches” to see the number of candidates interested in your opportunity.
                        </span><p />
                        <span>
                          3. Click “Connect Your Opportunity” to inform matching candidates their dream job awaits.
                        </span><p />
                      </div>
                    </div>
                  </template>
                </div>
              </b-col>
              <b-col class="mt-md-2 mt-lg-0" lg="3" md="12" sm="12">
                <div
                  class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                >
                  <b-row>
                    <b-col lg="12" md="6" sm="12">
                      <recruiter-ico-criteria-results
                        :criteria-items="criteriaItems"
                      />
                    </b-col>
                    <b-col class="mt-3 mt-md-0 mt-lg-3" lg="12" md="6" sm="12">
                      <div
                        class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                      >
                        <recruiter-ico-matching
                          :loading="loadingMatching"
                          :value="matchingValue"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <p class="font_size_1125rem font-weight-bold v3_color_teal mt-4">
              Let candidates know their ideal job is available.
            </p>
            <b-button @click="showComingSoonModal" variant="v3_teal_outline">
              Connect Your Opportunity
            </b-button>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <job-offer-preview-modal
      v-if="isPreviewModalVisible"
      :visible="isPreviewModalVisible"
      :criteria-items="criteriaItems"
      :number-of-matches="matchingValue"
      @cancel="isPreviewModalVisible = false"
      @modal-close="isPreviewModalVisible = false"
      @continue="onContinue"
    />
  </div>
</template>

<script>
import Api from '@/providers/Api';
import RecruiterIcoCriteria from '@/components/recruiter/ico/criteria/RecruiterIcoCriteria';
import RecruiterIcoMatching from '@/components/recruiter/ico/matching/RecruiterIcoMatching';
import RecruiterIcoCriteriaDetail from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaDetail';
import RecruiterIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaResults';
import { createAdditionalCriteriaItems } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import JobOfferPreviewModal from '@/components/pre-paywall-pages/recruiter/JobOfferPreviewModal';

export default {
  name: 'PrePaywallRecruiterIcoBrowser',
  components: {
    RecruiterIcoCriteriaDetail,
    RecruiterIcoMatching,
    RecruiterIcoCriteria,
    RecruiterIcoCriteriaResults,
    JobOfferPreviewModal,
  },
  data: function () {
    return {
      criteriaItems: [],
      selectedJobQuestion: null,
      loadingDetail: false,
      matchingValue: '-',
      loadingMatching: false,
      isPreviewModalVisible: false,
    };
  },
  created: function () {
    this.getData();
  },
  computed: {
    isSpecialtySubspecialtySpecified: function () {
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY
      );

      return (
        specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId
      );
      
    },
    JOB_QUESTION_TYPES: function () {
      return JOB_QUESTION_TYPES;
    },
    selectedJobQuestionId: function () {
      return this.selectedJobQuestion ? this.selectedJobQuestion.id : null;
    },
    isGuestRecruiter: function () {
      return this.$store.getters.isGuestRecruiter;
    },
  },
  methods: {
    showComingSoonModal: function () {
      this.$root.$emit('show-coming-soon-modal');
    },
    showNumberOfMatches : function(item_id){
      console.log(item_id);
    },
    getData: async function () {
      const additionalCriteria = createAdditionalCriteriaItems();
      const jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
      this.criteriaItems = [...additionalCriteria, ...jobQuestions];

      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        const values = JSON.parse(
          this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        );
        values.forEach(({ id, type, value }) => {
          if (!value) return;
          const index = this.criteriaItems.findIndex((i) => {
            return (
              i.id === id ||
              (i.type === JOB_QUESTION_TYPES.SPECIALTY &&
                type === JOB_QUESTION_TYPES.SPECIALTY) ||
              (i.type === JOB_QUESTION_TYPES.LOCATION &&
                type === JOB_QUESTION_TYPES.LOCATION)
            );
          });
          if (index === -1) return;
          this.$set(this.criteriaItems[index], 'value', { ...value });
        });
        this.updateMatching();
      }
    },
    onSetCriteriaValue: function (params) {
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', { ...params });
      this.updateCookies();
      this.$nextTick(() => {
        this.updateMatching();
      });
    },
    onChangeCriteria: async function (jobQuestion) {
       /*remove feature flag on release job builder */
      if (this.$store.getters.isProduction)
        return this.showComingSoonModal();

      const jqIndex = this.criteriaItems.findIndex(
        (jq) => jq.id === jobQuestion.id
      );
      this.selectedJobQuestion = this.criteriaItems[jqIndex];
    },
    updateMatching: async function () {
      this.loadingMatching = true;
      try {
        this.matchingValue = await Api.findNumberOfMatchesOnGuestIcoBrowser(
          this.criteriaItems
        );
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingMatching = false;
      }
    },
    showPreviewModal: function () {
      this.isPreviewModalVisible = true;
    },
    updateCookies: function () {
      const values = this.criteriaItems.map(({ id, type, value }) => {
        return { id, type, value };
      });
      //console.log("<<< values >>>", JSON.stringify(values));
      this.$cookies.set(
        COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES,
        JSON.stringify(values)
      );
    },
    onContinue: function () {
      this.isPreviewModalVisible = false;
      this.$router.push('/recruiter/sign-up');
    },
  },
};
</script>
<style scoped>
.mb-20{
  margin-bottom:25px !important;
}
</style>
